import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var certificateListRes;
export const certificateListTodo = createAsyncThunk('certificateList', async (id) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'learner/get_learner_certificate',
            data: {
                "user_id": id,
                "user_role": user_id.vrole_name,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return certificateListRes = res.data
    } catch (error) {
        return certificateListRes = error.response.data
    }
})


const certificateListSlice = createSlice({
    name: 'certificateList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(certificateListTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('certificateList', state.data)
            }
        });
        builder.addCase(certificateListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default certificateListSlice.reducer; 